import { createContext, useState, useContext } from 'react';

// 1. Create context
const SidebarContext = createContext();

// 2. Create provider
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, setIsSidebarOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};

// 3. Create hook to use the context
export const useSidebar = () => useContext(SidebarContext);
